import getServiceStatuses from '../../api/services/getServiceStatuses';
import SelectWithFetch from './SelectWithFetch';

const SelectServiceStatuses = (props) => {
  return <SelectWithFetch fetch={getServiceStatuses} {...props} />;
};

export default SelectServiceStatuses;
